import ChevronUp from 'assets/images/chevron-up.svg';
import ChevronDown from 'assets/images/chevron-down.svg';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

export const Expander = ({
  expanded,
  toggleExpanded,
}: {
  expanded: boolean;
  toggleExpanded: () => void;
}) => {
  return (
    <button css={showMoreButtonStyles} onClick={toggleExpanded}>
      <div css={showStyles}>
        <span css={showText}>{expanded ? 'Show less ' : 'Show more  '}</span>
        <img
          css={chevronStyles}
          src={expanded ? ChevronUp : ChevronDown}
          alt={'Show more'}
        />
      </div>
    </button>
  );
};

const showMoreButtonStyles = css({
  backgroundColor: 'transparent',
  border: 'none',
  marginTop: token('space.200'),
  padding: '0',
  textAlign: 'inherit',
  font: 'inherit',
  borderRadius: '0',
  appearance: 'none',
  fontWeight: '400',
  fontFamily: 'inter',
  '&:hover': {
    color: token('color.text.subtlest'),
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
      backgroundColor: token('color.background.neutral.subtle.hovered'),
    },
  },
  '&:active': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
      backgroundColor: token('color.background.neutral.subtle.pressed'),
    },
  },
});

const showText = css({
  fontSize: token('space.200'),
  lineHeight: token('space.300'),
});

const showStyles = css({
  display: 'flex',
  alignItems: 'center',
});

const chevronStyles = css({
  height: token('space.300'),
  width: token('space.300'),
  borderRadius: '4px',
  marginLeft: token('space.050'),
  '&:hover': {
    backgroundColor: token('color.background.neutral.subtle.hovered'),
  },
});
